import '../css/reset.css';
import '../css/site.css';
import { createMapManager } from './components/Map/MapManager.js';
import { DatasetManager } from './components/Map/DatasetManager.js';
import { initIntro } from './features/intro.js';
import { createNiraManager } from './features/niraManager.js';
import { initLogoAnimation } from './features/logoAnimation.js';
import { initMapInteractionDemo } from './features/mapInteractionDemo.js';
import { addNiraInteractiveCircle as niraCircle, removeNiraInteractiveCircle as removeNiraCircle } from './features/niraExample.js';
import { initMapStyleSwitcher } from './features/mapStyleSwitcher.js';
import './features/trafficLayer.js'; // Traffic layer handles its own initialization
import './features/saudiDataLayer.js'; // Saudi data layer handles its own initialization

// Make Nira circle functions available globally for style switching
window.addNiraInteractiveCircle = niraCircle;
window.removeNiraInteractiveCircle = removeNiraCircle;

// Initialize map and logo animation when DOM is loaded
document.addEventListener('DOMContentLoaded', async () => {
    try {
        // Initialize logo animation
        initLogoAnimation();

        // Initialize Nira viewer
        createNiraManager();

        const mapContainer = document.getElementById('map');
        if (!mapContainer) {
            console.error('[App] Map container not found');
            return;
        }
        
        // Removed premature Nira circle initialization

        // Debug data attributes
        console.log('[App] Map container data:', {
            token: mapContainer.dataset.token,
            style: mapContainer.dataset.mapStyle,
            debug: mapContainer.dataset.debug
        });

        // Get settings from data attributes
        const mapSettings = {
            style: mapContainer.dataset.mapStyle,
            center: [
                parseFloat(mapContainer.dataset.startLng || 0),
                parseFloat(mapContainer.dataset.startLat || 20)
            ],
            zoom: parseFloat(mapContainer.dataset.startZoom || 2.8),
            pitch: parseFloat(mapContainer.dataset.startPitch || 80),
            bearing: 0,
            projection: 'globe',
            fog: {
                color: 'hsl(199, 61%, 87%)',
                'high-color': 'rgb(36, 92, 223)',
                'horizon-blend': 0.02,
                'space-color': 'hsl(240, 46%, 5%)',
                'star-intensity': 0.4
            },
            terrain: {
                source: 'mapbox-dem',
                exaggeration: 1.5
            },
            mapbox_token: mapContainer.dataset.token,
            // Store intro animation settings
            introAnimation: {
                center: [
                    parseFloat(mapContainer.dataset.introLng || 45),
                    parseFloat(mapContainer.dataset.introLat || 24)
                ],
                zoom: parseFloat(mapContainer.dataset.introZoom || 1.8),
                pitch: parseFloat(mapContainer.dataset.introPitch || 0)
            }
        };

        if (!mapSettings.mapbox_token) {
            console.error('[App] Missing Mapbox token in map settings');
            console.log('[App] Full map settings:', mapSettings);
            return;
        }

        console.log('[App] Map settings:', mapSettings);

        // Create and initialize map
        const mapManager = createMapManager('map', mapSettings);
        await mapManager.initialize('map', mapSettings);

        // Add the Nira circle AFTER map initialization
        // This ensures the map is ready before we try to add the circle
        if (window.addNiraInteractiveCircle) {
            try {
                window.addNiraInteractiveCircle();
                console.log('[App] Added Nira interactive circle after map initialization');
            } catch (e) {
                console.error('[App] Error adding Nira circle after map initialization:', e);
            }
        }

        // Initialize intro animations and interactions
        initIntro(() => {
            console.log('[App] Intro complete');
            
            // Initialize map interaction demo after intro is complete
            initMapInteractionDemo();
            
            // Initialize map style switcher
            console.log('[App] Initializing map style switcher');
            initMapStyleSwitcher();
        });
    } catch (error) {
        console.error('[App] Initialization error:', error);
        console.error(error.stack);
    }
});
